<div *ngIf="template">
	<div class="d-flex">
		<div class="h3">Marketing Template</div>
		<div class="ms-auto">
			<p-button
				*ngIf="userService.user.role >= 5"
				pRipple
				styleClass="p-button-raised p-button-secondary m-2"
				[disabled]="!template.name"
				(click)="exportHtml()"
			>
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'file-export']" size="lg" class="ms-1 me-2"></fa-icon> Export to HTML
					</div>
				</ng-template>
			</p-button>
			<app-record-control-footer
				[hideCancel]=""
				[hideDelete]=""
				[hideSave]=""
				(onCancelChange)="templateChange.emit(undefined)"
				(onDeleteChange)="onDelete(template.sk)"
				(onSaveChange)="onSave()"
				[cancelDisabled]=""
				[deleteDisabled]=""
				[saveDisabled]="!template.name"
			></app-record-control-footer>
		</div>
	</div>
	<div class="card">
		<div class="d-flex justify-content-end mb-2">
			<a *ngIf="originatingBlastKey" [routerLink]="['/cc/marketing/blasts/' + originatingBlastKey]">Return to Blast Detail</a>
		</div>
		<div class="d-flex flex-column flex-fill mt-4">
			<div class="d-flex flex-fill">
				<span class="p-float-label flex-fill">
					<input pInputText #name type="text" name="name" [(ngModel)]="template.name" class="w-100" />
					<label for="name">Template Name</label>
				</span>
			</div>
			<div>
				<span class="p-float-label mt-4">
					<textarea pInputTextarea class="w-100" [(ngModel)]="template.description" id="description"></textarea>
					<label for="description">Description</label>
				</span>
			</div>
		</div>
	</div>

	<div class="card">
		<div class="container">
			<email-editor #editor editorId="editor" projectId="40813" (loaded)="editorLoaded($event)"></email-editor>
		</div>
	</div>
</div>

<p-dialog *ngIf="template" [(visible)]="initialSetup" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<p-header>
		<div class="h3">Template Setup</div>
	</p-header>
	<div class="d-flex flex-column flex-fill mt-4">
		<div class="d-flex flex-fill">
			<span class="p-float-label flex-fill">
				<input pInputText #name type="text" name="name" [(ngModel)]="template.name" class="w-100" />
				<label for="name">Template Name</label>
			</span>
		</div>
		<div>
			<span class="p-float-label mt-4">
				<textarea pInputTextarea class="w-100" [(ngModel)]="template.description" id="description"></textarea>
				<label for="description">Description</label>
			</span>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]="false"
			[hideDelete]="true"
			[hideSave]="false"
			(onCancelChange)="templateChange.emit(undefined)"
			(onSaveChange)="initialSetup = false"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="!template.name"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
